import { ChangeEvent, useEffect, useState } from 'react';
import { handleTrack } from '../../utils/tracker';
import { Button, ButtonVariants } from '../Atoms/Button';
import { If } from '../Atoms/Conditionals';
import { EmailValidator } from '../ContactSales/utils/validators';
import PaytaxServices from './paytax-service';

interface MailerProps<T> {
  emailData: T;
  slug: string;
  year?: number;
  buttonclass?: string;
}

const Mailer = <T,>({ emailData, slug, year, buttonclass }: MailerProps<T>) => {
  const [email, setEmail] = useState('');
  const [sendMailStatus, setSendMailStatus] = useState(false);
  const [errorState, setErrorState] = useState<{
    validity: boolean;
    error: string;
  }>({
    validity: true,
    error: '',
  });

  const handleEmail = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setEmail(e.target.value);
    setErrorState(EmailValidator(e.target.value));
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    try {
      setIsLoading(true);
      const response = PaytaxServices.sendTaxMail(email, emailData, slug, year);
      const result = await response;
      if (result.data.success) {
        setSendMailStatus(true);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Error calling API:', error);
    }
  };

  useEffect(() => {
    if (sendMailStatus) {
      const timer = setTimeout(() => {
        setSendMailStatus(false);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [sendMailStatus]);

  return (
    <>
      <If condition={!sendMailStatus}>
        <div>
          <div className="font-medium mb-1.5 text-base sm:text-s-12">
            Do you want this result?
          </div>
          <div className="flex gap-6 md:flex-col sm:block">
            <input
              onChange={handleEmail}
              className="flex-1 border border-grey-300 px-3 py-2.5 rounded-sm text-font-200 sm:mb-4 sm:w-full"
              placeholder="Please enter your email id"
              value={email}
            />
            <div
              className={`${
                email ? 'cursor-pointer' : 'pointer-events-none opacity-70'
              }`}
              id="test"
            >
              <Button
                variant={ButtonVariants.bluefilled}
                className={`px-10 w-48 md:w-36 sm:w-full sm:rounded-md sm:h-8  ${buttonclass}`}
                onClick={() => {
                  handleClick();
                  handleTrack({
                    label: 'get_tax_mail',
                    obj: this,
                    categoryName: 'paytax',
                  });
                }}
              >
                {isLoading ? 'Sending...' : 'Send'}
              </Button>
            </div>
          </div>
          <div className="text-font-200 text-s-14 mt-1.5  sm:text-s-12 font-medium">
            Your calculator result will be sent to your email shortly
          </div>
          <If condition={!errorState.validity}>
            <p className="text-red-350 text-s-14 font-medium inline-block">
              {errorState.error}
            </p>
          </If>
        </div>
      </If>
      <If condition={sendMailStatus}>
        <div className="text-font-200 text-left text-base font-medium mt-4">
          Email Sent Successfully.
        </div>
      </If>
    </>
  );
};

export default Mailer;
